'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugDescription$$anon$2() {
}
export { $c_Lapp_data_DrugDescription$$anon$2 as $c_Lapp_data_DrugDescription$$anon$2 };
$c_Lapp_data_DrugDescription$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lapp_data_DrugDescription$$anon$2.prototype.constructor = $c_Lapp_data_DrugDescription$$anon$2;
/** @constructor */
function $h_Lapp_data_DrugDescription$$anon$2() {
}
export { $h_Lapp_data_DrugDescription$$anon$2 as $h_Lapp_data_DrugDescription$$anon$2 };
$h_Lapp_data_DrugDescription$$anon$2.prototype = $c_Lapp_data_DrugDescription$$anon$2.prototype;
$c_Lapp_data_DrugDescription$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lapp_data_DrugDescription$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lapp_data_DrugDescription$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugDescription$$anon$2, "app.data.DrugDescription$$anon$2", ({
  Lapp_data_DrugDescription$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_DrugDescription$$anon$2 as $d_Lapp_data_DrugDescription$$anon$2 };
//# sourceMappingURL=app.data.-Drug-Description$$anon$2.js.map
